import { getFullName } from "../helpers/stringHelper";
import type { ApprenticeSupervisor } from "./apprenticeSupervisor";
import type { Company } from "./company";
import type { Occupation } from "./enums/occupation";
import type { Group } from "./group";
import type { Observation } from "./observation";
import type { Parent } from "./parent";
import type { SchoolDay } from "./schoolDay";
import type { UserType } from "./user";
import type { YearContext } from "./yearContext";

// TODO convert to Camel case
export type Apprentice = UserType & {
  short: string;
  apprentice_supervisor: ApprenticeSupervisor;
  occupation: Occupation;
  company: Company;
  school_days: SchoolDay[];
  year_context: YearContext;
  observations: Observation[];
  group: Group;
  parents: Parent[];
};

export function getApprenticeOptions(apprentices: Apprentice[]) {
  return apprentices.map((a) => ({ label: getFullName(a), value: a.id.toString() }));
}
